import type { Coordinate } from "ol/coordinate";
import { transform } from "ol/proj.js";

/*
 * transform coordinates from EPSG:4326 to EPSG:2056
 */
export function fromEPSG4326(coordinates: Coordinate): Coordinate {
  return transform(coordinates, "EPSG:4326", "EPSG:2056");
}

/*
 * transform coordinates from EPSG:2056 to EPSG:4326
 */
export function toEPSG4326(coordinates: Coordinate): Coordinate {
  return transform(coordinates, "EPSG:2056", "EPSG:4326");
}

export function inside4326Extent(coordinates: number[]): boolean {
  return (
    5.013926957923385 <= coordinates[0] &&
    coordinates[0] <= 11.477436312994008 &&
    45.35600133779394 <= coordinates[1] &&
    coordinates[1] <= 48.27502358353741
  );
}

type Coordinates = Coordinate[] | Coordinate[][] | Coordinate[][][];

/**
 *  Transforms coordinate or array (or array of array) of coordinates to Epsg2056
 * @param coords
 * @param from
 */
export function coordinatesToEpsg2056<T = Coordinate | Coordinates>(
  coords: Coordinate | Coordinates,
  from = fromEPSG4326,
): T {
  const convert = (coord: Coordinates): Coordinates => {
    return <Coordinates>coord.map((c) => {
      if (typeof c[0] === "number") return from(<Coordinate>c);
      return c.map((c2) => {
        if (typeof (<Coordinate>c2)[0] === "number") return from(<Coordinate>c2);
        return convert(<Coordinates>c2);
      });
    });
  };

  if (typeof coords[0] === "number") return <T>from(<Coordinate>coords);

  return <T>convert(<Coordinates>coords);
}
